import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree} from '@angular/router';
import {Observable, of} from 'rxjs';
import {LocalStorageService} from "../services/local-storage.service";
import {PathEnum} from "../shared/enums/path-enum";
import {isPublicPraticaNuovaUrl, savePostLoginReturnUrl} from "../shared/utils/post-login-return-url";


@Injectable({
    providedIn: 'root'
})
export class AuthGuard
{
    /**
     * Constructor
     */
    constructor(
        private _router: Router,
        private localStorageService: LocalStorageService
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Can activate
     *
     * @param route
     * @param state
     */
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean
    {
        const redirectUrl = state.url === '/sign-out' ? '/' : state.url;
        return this._check(redirectUrl);
    }

    /**
     * Can activate child
     *
     * @param childRoute
     * @param state
     */
    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
    {
        const redirectUrl = state.url === '/sign-out' ? '/' : state.url;
        return this._check(redirectUrl);
    }

    /**
     * Can load
     *
     * @param route
     * @param segments
     */
    canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean
    {
        return this._check('/');
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Check the authenticated status
     *
     * @param redirectURL
     * @private
     */
    private _check(redirectURL: string): Observable<boolean>
    {
        if (!this.localStorageService.getAccessToken()) {
            // Rotta "nuova pratica" pubblica: un anonimo può aprirla in sola lettura (la pagina
            // monta la modalità read-only e mostra la CTA "Accedi"). NON si redirige al login qui.
            if (isPublicPraticaNuovaUrl(redirectURL)) {
                return of(true);
            }

            // Prima del redirect al login salviamo il percorso richiesto come returnUrl: se punta a
            // una destinazione whitelisted, verrà onorato al termine dell'autenticazione (login
            // credenziali / passkey / SPID). L'helper valida anti open-redirect; i path fuori
            // whitelist non vengono salvati.
            savePostLoginReturnUrl(redirectURL);

            // Redirect to the root
            this._router.navigate(['/' + PathEnum.LOGIN]);

            // Prevent the access
            return of(false);
        }

        // Allow the access
        return of(true);
    }
}
